import { Badge, Tooltip } from "@mantine/core"

import { Tag, DatePreset } from "@costory/types/prisma-client"

interface BadgeGroupProps {
  datePreset?: DatePreset | null
  tags: Tag[]
  maxVisible?: number
}

const BadgeGroup = ({ datePreset, tags, maxVisible = 3 }: BadgeGroupProps) => {
  // Always show datePreset if present, then as many tags as allowed
  const visibleTagCount = datePreset ? maxVisible - 1 : maxVisible
  const visibleTags = tags.slice(0, visibleTagCount)
  const extraTags = tags.length - visibleTagCount
  const hiddenTags = tags.slice(visibleTagCount)

  return (
    <>
      {datePreset && (
        <Tooltip key={datePreset} label={datePreset}>
          <Badge color="blue" ml={4}>
            {datePreset}
          </Badge>
        </Tooltip>
      )}
      {visibleTags.map((tag) => (
        <Tooltip key={tag.id} label={tag.name}>
          <Badge color={tag.color} maw={120} ml={4}>
            {tag.name}
          </Badge>
        </Tooltip>
      ))}
      {extraTags > 0 && (
        <Tooltip
          label={
            <>
              {hiddenTags.map((tag) => (
                <Badge key={tag.id} bg={tag.color} mr={4}>
                  {tag.name}
                </Badge>
              ))}
            </>
          }
        >
          <Badge bg="surfaceSelected" ml={4}>
            +{extraTags}
          </Badge>
        </Tooltip>
      )}
    </>
  )
}

export default BadgeGroup
